import StaticMultiSelector from "components/Atoms/StaticMultiSelector"
import SearchFilter, {
  SearchFilterCallout,
} from "components/Organisms/SearchFilter"
import { PAYMENT_METHODS, TRANSACTION_STATUS } from "data/static.items"
import React from "react"
import { useDispatch } from "react-redux"
import { useSearchParams } from "react-router-dom"
import { useFilter } from "store/search-filter/search-filter.reducer"
import { RESET_SELECTED } from "store/selector.redux"

const FundFlowFilter = () => {
  const [filter, setFilter] = useFilter("fund-flow")
  const [, setParams] = useSearchParams()
  const dispatch = useDispatch()
  function resetSelected() {
    dispatch({
      type: RESET_SELECTED,
      path: "orders",
    })
  }
  return (
    <SearchFilter
      onClear={() => {
        setFilter({})
        resetSelected()
        setParams({})
      }}
      value={filter ?? {}}
      getValues={value => {
        setFilter(value)
        resetSelected()
      }}
      className="ml-3"
    >
      {/* <SearchFilterCallout className="od-filter-callout" title="Date Range">
        <CustomDateRange
          path="dateRange"
          className="mb-1 mt-2"
          label="Transaction"
          inline
          big={false}
        />
      </SearchFilterCallout> */}
      <SearchFilterCallout className="od-filter-callout" title="Status" fill>
        <StaticMultiSelector
          inline
          label="Status"
          formClassName="mt-2 mb-1"
          path="status"
          items={TRANSACTION_STATUS}
        />

        <StaticMultiSelector
          inline
          label="Method"
          formClassName="mt-2 mb-1"
          path="paymentMethods"
          items={PAYMENT_METHODS}
        />
      </SearchFilterCallout>
    </SearchFilter>
  )
}

export default FundFlowFilter
